
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/starred",
      function () {
        return require("private-next-pages/starred.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/starred"])
      });
    }
  